import { useCallback } from "react";
import { message as toast } from "antd";
import { useTranslation } from "react-i18next";

import { updateChatMessage } from "@fitness-app/app-store/src/store/reducers/chat/actions";
import { CHANNEL_ACCESS_DENIED_ERROR } from "@fitness-app/app-store/src/store/reducers/chat/types";

import { useAppDispatch } from "~/store/initializeStore";

type UpdateChatMessagePayload = Parameters<typeof updateChatMessage>[0];

/**
 * Reactions, edits and deletions are rejected by RLS for anyone who isn't assigned to the channel.
 * The UI hides those actions, but an unassignment can also land while the window is open — then the
 * write has to fail loudly instead of doing nothing (TRE-1714).
 */
export const useUpdateChatMessage = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation("chat");

  return useCallback(
    (payload: UpdateChatMessagePayload) => {
      void dispatch(updateChatMessage(payload))
        .unwrap()
        .catch((error: unknown) => {
          if (error === CHANNEL_ACCESS_DENIED_ERROR) {
            void toast.error(t("channel.readOnly"));
          }
        });
    },
    [dispatch, t],
  );
};
